import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationCodanData } from './Data';

export interface IntegrationCodanState extends BaseIntegrationState {
  adobeTracking: boolean;
}

export class IntegrationCodanModel extends BaseIntegration<IntegrationCodanData, IntegrationCodanState> {
  parse(data: IntegrationCodanData) {
    super.parse(data);
    this.state.adobeTracking = !!data.settings?.tracking?.adobe?.enabled;
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/custom/codan/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
